// extracted by mini-css-extract-plugin
module.exports = {"vzNavbar_Link":"navbar-item_vzNavbar_Link__1sEW0","vzNavOrangeBg":"navbar-item_vzNavOrangeBg__2moRq"};